import React, { Component } from 'react';
import logo from './logo.gif';
import './App.css';
import medica from './medica.png'
import { Stage } from 'ngl';
import "bootstrap/dist/css/bootstrap.min.css";

import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";



class App extends Component {
  // paste could be handled more gracefully.
  componentDidMount() {
    document.addEventListener('paste', this.paste);
  }


  componentWillUnount() {
    document.removeEventListener("paste", this.paste)
    this.state.stage.dispose();
  }
  constructor(props) {
    super(props);
    this.state = { stage: null, pdb: null, name: null,loading: false,selectedfile:null,canClick: true }
    this.paste = () => { setTimeout(() => document.activeElement.blur()); }
 }
 
  resetStage(e) {
    window.location.reload()
  }
  toggleLoader = () => {
    if(this.state.loading){
      this.setState({loading: true})
    }else{
      this.setState({loading: false})
    }
 }

  pdb(content, viewportId="viewport") {
    var pdb;
 
    document.getElementById('viewport').innerHTML="";
    if (content.files) {
      pdb = content.files[0]
      this.setState({ stage: new Stage(viewportId) })
      this.setState({ pdb });
      setTimeout(() => this.state.stage.loadFile(pdb, { ext: "pdb", defaultRepresentation: true }),this.setState({ loading: false }))
    }
    else {
      this.setState({loading:true})
      fetch('https://fastaseq.herokuapp.com/predict', {
        method: 'POST',
        headers: {
          'content-Type': 'application/json'
        },
        body: JSON.stringify({ fastaseq: content.value })
      })
        .then(res => { return res.json() })
        .then(data => {
          pdb = new Blob([data["fasta"]], { type: 'text/plain' });
          content.value = "";
          this.setState({ stage: new Stage(viewportId) })
          this.setState({ pdb });
          setTimeout(() =>
            this.state.stage.loadFile(pdb, { ext: "pdb", defaultRepresentation: true }),this.setState({ loading: false }))
        })
        .catch(error => console.log(error))



    }
  }
  render() {
    const { loading } = this.state;
   
    return (
      
  <div className="App"  >
    <img src={medica} className="logo"></img>
        <Container  >
          <Row >

            <Col md="4">
             <h1>3D Modeling</h1>
                <div className='titre-label'>Target Sequence(s):(Format must be FASTA)</div>
                 <textarea rows="6" wrap="soft"  type="text" id="pdbtext" onChange={e =>{ this.setState({ name: e.target });this.setState({canClick:false})}} />
                <div className='titre-label'>Or Upload a PDB file : </div>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroupFileAddon01">Upload</span>
                  </div>
                  <div className="custom-file">
                    <input type="file" className="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" onChange={e => {this.setState({ name: e.target });this.setState({selectedfile: e.target.files[0].name});this.setState({canClick:false})}}/>
                    <label className="custom-file-label" htmlFor="inputGroupFile01">{this.state.selectedfile==null? "Chose file" :this.state.selectedfile }</label>
                  </div>
                </div><br />
                <Button className="btn btn-primary" type="button" onClick={(e) => {this.setState({loading:true});this.pdb(this.state.name);console.log(this.state.loading) }}disabled={loading||this.state.canClick}>

                {loading && (
                <i className="fa fa-refresh fa-spin"/> )}
                    {loading && <span>Loading Data from Server</span>}
                      {!loading && <span>SUBMIT</span>}


                </Button>
                &nbsp;&nbsp;&nbsp; <Button className="btn btn-danger" type="reset" onClick={(e) => {this.resetStage();}}>Reset</Button>
       
              
            </Col>
            
           <Col md="7"  > <div id="viewport" >
           {loading?
           <div id="view">
           <img src={logo}  className="img" /></div>:null}
             </div>
            </Col>
        
          </Row>
        </Container>
      
       




      </div>


    );}}
  
  
  export default App;
